// Delete Transaction Use Case

import {DistributionRepository} from '../repository/DistributionRepository';

export class DeleteTransactionUseCase {
  constructor (private distributionRepository: DistributionRepository) {}

  async execute (transactionId: string): Promise<void> {
    try {
      // Business Logic Validation
      if (!transactionId || transactionId.trim() === '') {
        throw new Error('Transaction ID is required');
      }

      // Validate transaction ID format (should be numeric)
      if (!/^\d+$/.test(transactionId)) {
        throw new Error('Invalid transaction ID format');
      }

      await this.distributionRepository.deleteTransaction(transactionId);
    } catch (error) {
      throw error;
    }
  }
}
